import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { withPasswordManagerRefresh } from "./passwordManagerRequest";
import { getPasswordManagerAuthHeaders, passwordManagerUrl } from "./personaApi";
import { ICredentialPersona, ICredentialPersonaUpdate } from "./resetAutomationTypes";

interface IUpdateCredentialPersonaState {
	loading: boolean;
	error: string | null;
}

const initialState: IUpdateCredentialPersonaState = {
	loading: false,
	error: null,
};

export const updateCredentialPersona = createAsyncThunk<ICredentialPersona, ICredentialPersonaUpdate>(
	"passwordManager/updateCredentialPersona",
	async (payload, { rejectWithValue, dispatch }) => {
		try {
			const { credentialId, ...body } = payload;
			const res = await withPasswordManagerRefresh(dispatch, () =>
				axios.put<ICredentialPersona>(passwordManagerUrl(`/Credentials/${credentialId}/persona`), body, {
					headers: getPasswordManagerAuthHeaders(),
				}),
			);
			return res.data;
		} catch (error: unknown) {
			return rejectWithValue(error instanceof Error ? error.message : "Failed to save credential persona");
		}
	},
);

const updateCredentialPersonaSlice = createSlice({
	name: "passwordManager/updateCredentialPersona",
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder
			.addCase(updateCredentialPersona.pending, (state) => {
				state.loading = true;
				state.error = null;
			})
			.addCase(updateCredentialPersona.fulfilled, (state) => {
				state.loading = false;
			})
			.addCase(updateCredentialPersona.rejected, (state, action) => {
				state.loading = false;
				state.error = (action.payload as string) || action.error.message || "Failed to save credential persona";
			});
	},
});

export const updateCredentialPersonaReducer = updateCredentialPersonaSlice.reducer;
